module.exports = __webpack_public_path__ + "static/favicon-4bf79d9d4e7557e19f41b61ff39ffa94.ico";